import { render, staticRenderFns } from "./posterDraw.vue?vue&type=template&id=4ea69569&scoped=true"
import script from "./posterDraw.vue?vue&type=script&lang=js"
export * from "./posterDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea69569",
  null
  
)

export default component.exports